import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const ImageUploadBox = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
  padding-left: 16px;
  margin: 16px 0 0;

  @media only screen and (max-width: 485px) {
    padding-left: 0;
  }
`